<!--
 * @Author: your name
 * @Date: 2020-02-18 17:12:51
 * @LastEditTime: 2021-05-28 23:53:35
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/components/Show.vue
 -->
<template>
  <div class="show" :style="`background: url('${require('../assets/bg3.jpg')}') no-repeat; background-size: 100% 100%;`">
  <!-- <img class="sub-logo" src="../assets/logo4.png"> -->
  <img class="sub-logo2" src="../assets/logo5.png">
    <div class="body">
        <div class="content">
            <div class="video" id="video">
                <div class="player_loading">
                    <div class="load-container load8">
                    <div class="loader"></div></div>
                </div>
            </div>
            <div class="title">{{ this.info.title }}</div>
            <!-- <div class="intro">
             {{ this.info.presenter }}
            </div> -->
            <div class="title2">专家简介:
                <span class="seeNum">观看量：{{ seeNum }}人</span>
            </div>
            <div class="intro">
             {{ this.info.intro2 }}
            </div>
        </div>
    </div>

     <div class="footer"  @click="goback()">
      <img class="goback" src="../assets/goback.png" >
    </div>
  </div>
</template>
<script>
import { Http } from "@/utils/http.js"
import api from "@/config/api.js"
import Cookies from 'js-cookie'

export default {
  name: 'List',
  data() {
    return {
        player: '',
        vid: '',
        count: 0,
        uid: '',
        info: {},
        seeVideoId: 0, // 观看页面上报更新的id 值
        browseTime: 1, // 页面浏览时长
        updateTime: 5,  // 页面每次上报的间隔
        browseId: 0, // 浏览页面上报更新的id 值

        interval: '', // 轮询计数
        interval2: '', // 轮询计数
        seeNum : 0, // 观看次数
    }
  },

  methods: {
       // 返回上一页
    goback(){
      this.$router.go(-1)
    },
    // 播放视频
    s2j_onVideoPlay() {
      console.log('视频播放')
      if(this.count == 0){
          this.interval = setInterval(this.upViewTime, 5000)
       }  
      this.count ++;
    },
    // 跟新视频播放时间
    upViewTime(){
        console.log('跟新播放时长---88888')
       var sec4=this.player.j2s_getCurrentTime();
       console.log(sec4)
       console.log('跟新播放时长---77777')
      //return 
       if(this.vid > 0 && sec4 > 0){
          if(this.count > 0){
              if (this.uid) {
                let data = {}
                data.uid = this.uid
                data.vid = this.vid
                data.see_time = sec4
                data.id = this.seeVideoId
                var that = this
                Http.post(api.updateVideoSee, data).then(response => {
                    if (response.code == 1) {
                        if(that.seeVideoId == 0){
                            //首次观看
                            that.seeVideoId = response.id
                        }
                    } 
                })
            }
              
          }
      }
    },
    fininshVideoJs(){
        console.log('视频js 加载完成')
        const polyvPlayer = window.polyvPlayer;
        this.player = polyvPlayer({
          wrap: '#video',
            'width': '100%',
          'height': '0',
          'vid': this.info.src_id
        });
        setInterval(this.upViewTime(),2000);
    },
    loadScript(src, callback){
        var script = document.createElement('script');
        var head = document.getElementsByTagName('head')[0];
        var loaded;
        script.src = src;
        if (typeof callback === 'function') {
            script.onload = script.onreadystatechange = function () {
            if (!loaded && (!script.readyState || /loaded|complete/.test(script.readyState))) {
                script.onload = script.onreadystatechange = null;
                loaded = true;
                callback();
            }
            }
        }
        head.appendChild(script);
    },
    // 获取视频信息
    getVideoInfo () {
        // 视频数据
        let data = {}
        data.id = this.vid
        Http.post(api.getVideoInfoById, data).then(response => {
            if (response.code == 1) {
                // 写入返回的cookie 值
                this.info = response.data
                document.title = response.data.title
                this.seeNum = response.num
                // 数据存在则调用视频数据
                if(this.info){
                    this.loadScript('http://player.polyv.net/resp/vod-player/latest/player.js',this.fininshVideoJs)
                }
            } 
        })
    },

    // 统计浏览时长
    updateBrowseTime () {
        // 判断用户id 是否存在
        if (this.uid) {
            let data = {}
            data.uid = this.uid
            data.type = 2 // 视频详细页
            data.type_id = this.vid
            data.see_time = this.browseTime
            data.id = this.browseId
            var that = this
            Http.post(api.browseTime, data).then(response => {
                if (response.code == 1) {
                   if(that.browseId == 0){
                       //首次观看
                       that.browseId = response.id
                   }
                } 
            })
            this.browseTime = this.browseTime + 5
        }
    }
  },
  mounted: function() {
    // 获取视频详细
    this.vid = this.$route.query.id
    this.uid = Cookies.get('uid')
    // 跳转到首页
    if(!this.uid){
        this.$router.push({ name: "Index"})
    }
    // 调用视频
    this.getVideoInfo()
    // 跟新页面停留时间
    this.interval2 = setInterval(this.updateBrowseTime, 5000)
    // 将backToday方法绑定到window下面，提供给外部调用
     window['s2j_onVideoPlay'] = () => {
        this.s2j_onVideoPlay()
     }
  },
  destroyed() {
    //清除轮询
    clearInterval(this.interval);
    clearInterval(this.interval2);
  }
}
</script>

<style lang="less" scoped>
.show {
    .sub-logo {
        position: absolute;
        width: 100px;
        top: 20px;
        left: 20px;    
    }
    .sub-logo2 {
        position: absolute;
        width: 40px;
        top: 20px;
        right: 20px;    
    }
    display: flex;
    min-height: 100vh;
    flex-direction: column;
     .header {
        min-height: 100px;
        img {
            width: 100%;
            display: block;
        }
    }
    .body {
        flex:1;
        padding-left: 30px;
        padding-right: 30px;
        color: #fff;
        .video {
            margin-top: 75px;
        }
        .title {
            margin-top: 30px;
          //  margin-bottom: 16px;
            font-size: 16px;
        }
        .title2 {
            margin-top: 12px;
            font-size: 16px;
            .seeNum {
                font-size: 12px;
                float: right;
                margin-top: 4px;
                margin-right: 8px;
            }
        }
        .intro {
            font-size: 14px;
            white-space: pre-line;
        }
  }

   .footer {
      position: fixed;
      bottom: 0px;
      right: 0;
      .goback {
        width: 120px
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Show.vue